/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Mojo QA environment overrides.
 *
 * @author Mohamed yasar arabath M
 */

const mojoQa = {
  ENVIRONMENT: 'qa',
  CLIENT_ID: 'jbxnqvJw6NJEMzJLBQbMSVWpgrZUUC0g',
  SSI_CLIENT_ID: 'I3l3CiMiPkq8LpGSK9IMRcHBJlSQKhYH',
  TENANT_KEY_ETEXT: 'daa92f39-9a75-4c2a-abaf-2269d70f7422',
  TENANT_KEY_ETEXT_PDF: 'daa92f39-9a75-4c2a-abaf-2269d70f7422',
  BERLIN: {
    STREAM_BASE_URL: 'https://plus-qa.pearson.com/ber-api/api',
    TENANT_ID: '7408ccc0-86ac-40e5-9d6d-9e1eae93900c',
    TENANT_KEY: 'f917690b-f60f-4f77-93c8-2ef8eacf5d3e'
  },
  PREP_FLASH_CARDS_TENANT_ID: '30258aed-46bb-4ec5-909e-ecea2431772b',
  PREP_FLASH_CARDS_TENANT_KEY: '297a5917-24fa-43fe-a27b-426126bd7cf4'
};

module.exports = mojoQa;
